import { Guid, Nillable } from '@web/utils';

export class AdminDictionaryCountryCollectionItem {
  public constructor(
    private readonly _data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      createdAt: Date;
      id: Guid;
      label: string;
      position: number;
      isoCode?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this._data.id;
  }

  public get position(): number {
    return this._data.position;
  }

  public get label(): string {
    return this._data.label;
  }

  public get isoCode(): Nillable<string> {
    return this._data.isoCode;
  }

  public get createdAt(): Date {
    return this._data.createdAt;
  }

  public get canBeRemoved(): boolean {
    return this._data.canBeRemoved;
  }

  public get canBeEdited(): boolean {
    return this._data.canBeEdited;
  }
}
